import { useLocation, useHistory } from 'react-router-dom';
import { PiMicrosoftPowerpointLogoFill } from "react-icons/pi";
import { LuPresentation } from "react-icons/lu";


const GoToPresentationButton = () => {
  const location = useLocation();
  const history = useHistory();

  const handleClick = () => {
    const currentPath = location.pathname.replace(/^\//, ''); 
    const presentationPath = `/presentation/${currentPath}`;
    history.push(presentationPath);
  };

  return (
    <button
      className="d-flex align-items-center presentation-button"
      style={{
        background: 'transparent',
        border: 'none',
        color: 'white',
        padding: '0.375rem 0.75rem',
        cursor: 'pointer',
        fontSize: '0.9rem',
        height: '100%'

      }}
      onClick={handleClick}
    >
      <LuPresentation size={20}/>
    </button>
  );
};

export default GoToPresentationButton;
